
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 1440 1114","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('filter',{attrs:{"x":"-3.4%","y":"-4.3%","width":"106.8%","height":"109%","filterUnits":"objectBoundingBox","id":"c"}},[_c('feOffset',{attrs:{"dy":"2","in":"SourceAlpha","result":"shadowOffsetOuter1"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"15","in":"shadowOffsetOuter1","result":"shadowBlurOuter1"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0.0827989046 0 0 0 0 0.17103242 0 0 0 0 0.300441576 0 0 0 0.0526660839 0","in":"shadowBlurOuter1"}})]),_c('rect',{attrs:{"id":"d","x":"48","y":"49","width":"1344","height":"1017","rx":"8"}}),_c('path',{attrs:{"id":"a","d":"M0 0h1440v1114H0z"}})]),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('mask',{attrs:{"id":"b","fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#a"}})]),_c('use',{attrs:{"fill":"#FFF","xlink:href":"#a"}}),_c('g',{attrs:{"mask":"url(#b)","stroke":"#3274ba","stroke-linecap":"square"}},[_c('path',{attrs:{"d":"M77.5 232.5l232-232M105 232.5L337 .5m-204 232L365 .5m-204 232L393 .5m-204 232L421 .5m-204 232L449 .5m-204 232L477 .5"}})]),_c('circle',{attrs:{"fill":"#3274ba","mask":"url(#b)","cx":"1314.5","cy":"29","r":"362"}}),_c('circle',{attrs:{"fill":"#3274ba","mask":"url(#b)","cx":"16.5","cy":"1177.5","r":"361.5"}}),_c('g',{attrs:{"mask":"url(#b)"}},[_c('use',{attrs:{"fill":"#000","filter":"url(#c)","xlink:href":"#d"}}),_c('use',{attrs:{"fill":"#FFF","xlink:href":"#d"}})])])])
          )
        }
      }
    